import http from './interceptor';

const buildConfig = (options = {}) => {
  const { orgId, headers, suppressToast, ...rest } = options;
  return {
    headers: {
      ...headers,
      ...(orgId && { 'X-Org-Id': orgId }),
    },
    ...(suppressToast && { _suppressToast: true }),
    ...rest,
  };
};

export async function getResource(url, options = {}) {
  try {
    const response = await http.get(url, buildConfig(options));
    return response.data;
  } catch (error) {
    console.error('Failed to Get:', error);
    throw error;
  }
}

export async function postResource(url, body, options = {}) {
  try {
    const response = await http.post(url, body, buildConfig(options));
    return response.data;
  } catch (error) {
    console.error('Failed to Create:', error);
    throw error;
  }
}

export async function putResource(url, body, options = {}) {
  try {
    const response = await http.put(url, body, buildConfig(options));
    return response.data;
  } catch (error) {
    console.error('Failed to Update:', error);
    throw error;
  }
}

export async function patchResource(url, body, options = {}) {
  try {
    const response = await http.patch(url, body, buildConfig(options));
    return response.data;
  } catch (error) {
    console.error('Failed to Patch:', error);
    throw error;
  }
}

export async function deleteResource(url, options = {}) {
  try {
    const response = await http.delete(url, buildConfig(options));
    return response.data;
  } catch (error) {
    console.error('Failed to Delete:', error);
    throw error;
  }
}

function extractFilenameFromDisposition(header) {
  if (!header) return null;
  const starMatch = /filename\*=(?:UTF-8''|utf-8'')?([^;]+)/i.exec(header);
  if (starMatch) {
    try {
      return decodeURIComponent(starMatch[1].trim().replace(/^"|"$/g, ''));
    } catch {
      // fall through to plain filename match
    }
  }
  const plainMatch = /filename="?([^"; ]+)"?/i.exec(header);
  return plainMatch ? plainMatch[1].trim() : null;
}

export async function downloadResource(url, filename, options = {}) {
  try {
    const response = await http.get(url, { ...buildConfig(options), responseType: 'blob' });
    const finalFilename = extractFilenameFromDisposition(response.headers?.['content-disposition']) || filename;
    const href = URL.createObjectURL(response.data);
    const a = document.createElement('a');
    a.href = href;
    a.download = finalFilename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(href);
  } catch (error) {
    console.error('Failed to Download:', error);
    throw error;
  }
}

export const apiHelper = {
  getResource,
  postResource,
  putResource,
  patchResource,
  deleteResource,
  downloadResource,
};
